import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Spinner } from "react-bootstrap";
import ModalConfirmar from "../../components/ModalConfirmar";
import * as tiposCambioApi from "../../api/tiposCambio";
import * as monedasApi from "../../api/monedas";

export default function TiposCambioMant() {
  const [tipos, setTipos] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [aEliminar, setAEliminar] = useState(null);
  const [form, setForm] = useState({ monedaOrigenId: "", monedaDestinoId: "", tasa: "" });
  const [guardando, setGuardando] = useState(false);

  const cargar = async () => {
    setCargando(true);
    try {
      const [t, m] = await Promise.all([tiposCambioApi.listarTiposCambio(), monedasApi.listarMonedas()]);
      setTipos(t);
      setMonedas(m.filter((x) => x.activo));
    } finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrir = (t) => {
    setEditando(t);
    setForm(t ? { monedaOrigenId: t.monedaOrigenId, monedaDestinoId: t.monedaDestinoId, tasa: t.tasa }
               : { monedaOrigenId: "", monedaDestinoId: "", tasa: "" });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await tiposCambioApi.upsertTipoCambio({
        tipoCambioId: editando?.tipoCambioId ?? null,
        monedaOrigenId: Number(form.monedaOrigenId),
        monedaDestinoId: Number(form.monedaDestinoId),
        tasa: Number(form.tasa),
        fecha: null,
      });
      setShowModal(false);
      cargar();
    } finally { setGuardando(false); }
  };

  const confirmarEliminar = async () => {
    await tiposCambioApi.eliminarTipoCambio(aEliminar.tipoCambioId);
    setAEliminar(null);
    cargar();
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Mantenimiento &gt; Tipo de Cambio</h4>
        <Button size="sm" variant="primary" onClick={() => abrir(null)}><i className="bi bi-plus-lg me-1"></i>Nuevo tipo de cambio</Button>
      </div>

      {cargando ? <Spinner animation="border" /> : (
        <div className="fs-card p-0 overflow-hidden">
          <Table responsive hover className="table-fs table-fs-responsive mb-0 align-middle">
            <thead><tr><th>De</th><th>A</th><th className="text-end">Tasa</th><th>Fecha</th><th></th></tr></thead>
            <tbody>
              {tipos.map((t) => (
                <tr key={t.tipoCambioId}>
                  <td data-label="De">{t.monedaOrigen}</td>
                  <td data-label="A">{t.monedaDestino}</td>
                  <td data-label="Tasa" className="text-end fw-semibold">{t.tasa}</td>
                  <td data-label="Fecha">{new Date(t.fecha).toLocaleDateString("es-ES")}</td>
                  <td data-label="Acciones" className="text-end">
                    <Button size="sm" variant="outline-primary" className="me-1" onClick={() => abrir(t)}><i className="bi bi-pencil"></i></Button>
                    <Button size="sm" variant="outline-danger" onClick={() => setAEliminar(t)}><i className="bi bi-trash"></i></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton><Modal.Title style={{ fontSize: "1.1rem" }}>{editando ? "Editar tipo de cambio" : "Nuevo tipo de cambio"}</Modal.Title></Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Moneda origen</Form.Label>
              <Form.Select value={form.monedaOrigenId} onChange={(e) => setForm({ ...form, monedaOrigenId: e.target.value })} required>
                <option value="">Selecciona...</option>
                {monedas.map((m) => <option key={m.monedaId} value={m.monedaId}>{m.codigo} — {m.nombre}</option>)}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Moneda destino</Form.Label>
              <Form.Select value={form.monedaDestinoId} onChange={(e) => setForm({ ...form, monedaDestinoId: e.target.value })} required>
                <option value="">Selecciona...</option>
                {monedas.map((m) => <option key={m.monedaId} value={m.monedaId}>{m.codigo} — {m.nombre}</option>)}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tasa</Form.Label>
              <Form.Control type="number" step="0.000001" value={form.tasa} onChange={(e) => setForm({ ...form, tasa: e.target.value })} required />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
            <Button type="submit" variant="primary" disabled={guardando}>{guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <ModalConfirmar show={!!aEliminar} titulo="Eliminar tipo de cambio" mensaje="¿Eliminar este registro de tipo de cambio?"
        onConfirmar={confirmarEliminar} onCancelar={() => setAEliminar(null)} />
    </div>
  );
}
